import { hasValue } from 'src/shared/utils/common';

import type { GeoLoadRigOperation } from './geo-load-rig-operation.entity';
import type { GeoLoadSection } from './geo-load-section.entity';
import type { GeoLoadStage } from './geo-load-stage.entity';
import type { GeologicalLoadService } from './geological-load-service';
import type { GeologicalLoad } from './geological-load.entity';

export class GeologicalLoadValidation {
  validateCoreSamplingIntervalId = (geoLoad: GeologicalLoad): boolean => {
    if (geoLoad.coreSelection && !geoLoad.coreSamplingIntervalId.length) {
      geoLoad.addError('coreSamplingIntervalId', 'geologicalLoad:errors.requiredField');
      return false;
    }

    return true;
  };

  validateTestingFormationWorkAmount = (geoLoad: GeologicalLoad): boolean => {
    if (geoLoad.testingFormationWork && !hasValue(geoLoad.testingFormationWorkAmount)) {
      geoLoad.addError('testingFormationWorkAmount', 'geologicalLoad:errors.requiredField');
      return false;
    }

    if (hasValue(geoLoad.testingFormationWorkAmount) && geoLoad.testingFormationWorkAmount < 1) {
      geoLoad.addError('testingFormationWorkAmount', 'geologicalLoad:errors.valueShouldBeMoreThan1');
      return false;
    }

    return true;
  };

  validateNumberOfDataInterpretationOperations = (geoLoad: GeologicalLoad): boolean => {
    if (geoLoad.dataInterpretation && !hasValue(geoLoad.numberOfDataInterpretationOperations)) {
      geoLoad.addError('numberOfDataInterpretationOperations', 'geologicalLoad:errors.requiredField');
      return false;
    }

    if (hasValue(geoLoad.numberOfDataInterpretationOperations) && geoLoad.numberOfDataInterpretationOperations < 1) {
      geoLoad.addError('numberOfDataInterpretationOperations', 'geologicalLoad:errors.valueShouldBeMoreThan1');
      return false;
    }

    return true;
  };

  validateGeoLoadEntity = (geoLoad: GeologicalLoad): boolean => {
    let isValid = true;

    if (!this.validateCoreSamplingIntervalId(geoLoad)) {
      isValid = false;
    }

    if (!this.validateTestingFormationWorkAmount(geoLoad)) {
      isValid = false;
    }

    if (!this.validateNumberOfDataInterpretationOperations(geoLoad)) {
      isValid = false;
    }

    return isValid;
  };

  validateSection = (section: GeoLoadSection): boolean => {
    return this.validateGeoLoadEntity(section.geologicalLoad);
  };

  validateStage = (stage: GeoLoadStage): boolean => {
    if (!stage.sections.length) {
      return this.validateGeoLoadEntity(stage.geologicalLoad);
    }

    return stage.sections.every((section) => this.validateSection(section));
  };

  validateRigOperation = (rigOperation: GeoLoadRigOperation): boolean => {
    if (!rigOperation.stages.length) {
      return this.validateGeoLoadEntity(rigOperation.geologicalLoad);
    }

    return rigOperation.stages.every((stage) => this.validateStage(stage));
  };

  validateGeologicalLoad = (geoLoad: GeologicalLoadService): boolean => {
    if (!geoLoad.geoLoadRigOperations.length) {
      return this.validateGeoLoadEntity(geoLoad.geotaskGeoLoad);
    }

    return geoLoad.geoLoadRigOperations.every((rigOperation) => this.validateRigOperation(rigOperation));
  };
}
